<template>
    <div>
      <input
      :type="type"
      :name="name"
      :min="min"
      :class="{'error': error, 'success': success, 'disabled': disabled}"
      :disabled="disabled"
      :value="value"
      @keyup.enter="$emit('enter')"
      @input="$emit('input', $event.target.value)"
      class="form-control"
      :placeholder="placeholder">
    </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    type: String,
    value: {
      type: [String, Number],
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    success: {
      type: Boolean,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    min: {
      type: String,
      required: false
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.error {
  border-color: red !important;
}
.success {
  border-color: #58d858 !important;
}
.disabled {
  border-color: rgb(155, 155, 155);
  background-color: rgb(214, 214, 214);
}
</style>
